const updateTileLabels = (obj) => {
    if (obj !== undefined) {
        const taggedTiles = Array.from(document.querySelectorAll('.tile')).filter((tile) =>
            tile.dataset.tags !== undefined);
        taggedTiles.forEach((tile) => {
            const currentTile = tile;
            const indexOfNotFound = -1;
            Object.entries(obj).forEach(([key, value]) => {
                if (currentTile.dataset.tags.indexOf(key) !== indexOfNotFound) {
                    // Changing the label text example
                    currentTile.querySelector('a.view').innerText = value;

                    // Adding a description label
                    const newParagraph = document.createElement('p');
                    newParagraph.classList.add('custom-tile-label');
                    const newParagraphText = document.createTextNode(key);
                    newParagraph.appendChild(newParagraphText);
                    const descriptionH3 = currentTile.querySelector('.description .h3like');
                    if (descriptionH3) {
                        if (currentTile.querySelector('.custom-tile-label') === null) {
                            currentTile
                                .querySelector('.description')
                                .insertBefore(newParagraph, descriptionH3);
                        }
                    }
                }
            });
        });
    }
};

module.exports = updateTileLabels;


// WEBPACK FOOTER //
// ./custom-modules/tileLabels.js